// extracted by mini-css-extract-plugin
module.exports = {"header__bg":"styles_header__bg__YsP3N","header":"styles_header__YwGZ1","pulse":"styles_pulse__IoEXu","jump":"styles_jump__JDK2s"};